import axios from 'axios';
import { OutcomeRequest, OutcomeResponse } from '../types/outcomeTypes';

const BACKEND_API_URL = process.env.REACT_APP_BACKEND_API_URL ?? 'http://localhost:3001';

// Calls the Express proxy at /api/outcome/update, which forwards to the
// Outcome Azure Function with the function key kept server-side.
export async function submitOutcomeUpdate(
    request: OutcomeRequest,
    authToken: string,
    allowedProgramId: string
): Promise<OutcomeResponse> {
    const response = await axios.post<OutcomeResponse>(
        `${BACKEND_API_URL}/api/outcome/update`,
        request,
        {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`,
                'Allowed-Program-Id': allowedProgramId,
            },
        }
    );
    return response.data;
}
